import router from './router'
import NProgress from 'nprogress'
import Cookies from 'js-cookie';
import {getLoginUserInfo} from '@/api/user'
import 'nprogress/nprogress.css'

NProgress.configure({showSpinner: false});

router.beforeEach((to, from, next) => {
    NProgress.start()
    if (to.matched.some(m=>m.meta.requireLogin)){
        if (Cookies.get("TipDM-Login-Token")) {
            next();
        }else {
            Cookies.set("RETURN_URL",to.path);
            window.open(window.location.origin + "/login","_self");
        }
    }else {
        if(Cookies.get("RETURN_URL")) {
            let returnUrl = Cookies.get("RETURN_URL");
            Cookies.remove("RETURN_URL");
            next(
                {path: returnUrl}
            );
        }else {
            next();
        }
    }
})


router.afterEach(() => {
    NProgress.done()
})
